
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import Select from 'react-select';
import LockRounded from '@material-ui/icons/LockRounded';
import SignatureCanvas from 'react-signature-canvas';
import { renderInfoForType } from '../../../utils/helpers';
import styles from '../../workorders/Detail/workOrderDetail.module.scss';
import attachmentStyles from './detail.module.scss';
import Collapsible from '../../../components/collapsible/Collapsible';
import Clickable from '../../../components/clickable/Clickable';
import Modal from '../../../components/modal';
import FileSlider from '../../../components/photoCarousel/FileSlider';
import Button from '../../../components/button';
import Checkbox from '../../../components/checkbox/checkbox';
import CustomFields from '../../../components/customFields/CustomFields';
import CustomFieldDetail from '../../../components/customFields/CustomFieldDetail';
import closeIcon from '../../../icons/closeIcon.svg';

class ApplicationInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalA: false,
      modalB: false,
      modalC: false,
      signature: null,
      ssnView: false
    };
    this.sigCanvas = React.createRef({});
  }

  getPlaceOfBirth = (application) => {
    const pob = application?.answer_schema?.fields?.filter(
      fil => fil.id === 'place_of_birth' && fil.type === 'address'
    ) || [];
    if (pob.length > 0) {
      // When the field exists in the schema
      if (application?.response?.place_of_birth?.city && application?.response?.place_of_birth?.city !== '') {
        return `${application?.response?.place_of_birth?.city}, ${application?.response?.place_of_birth?.state}`;
      }
      if (application?.response?.place_of_birth?.state !== '') {
        return application?.response?.place_of_birth?.state;
      }
    } else {
      // When the field does not exist in the schema
      return application?.response?.place_of_birth?.label || '';
    }
    return '';
  };


  openPhotoModal = (idx) => {
    this.setState({ modalB: true, initialSlide: idx });
  };

  openPhotoModalA = (idx) => {
    this.setState({ modalA: true, initialSlideA: idx });
  };

  openPhotoModalC = (idx) => {
    this.setState({ modalC: true, initialSlideC: idx });
  };

  handleSignatureEnd = () => {
    const { handleAnswerChanged, application } = this.props;
    if (application && (application?.current_stage==='signatory_review' || application?.current_stage==='sigantory_review')) {
      this.setState({
        signature: this.dataURLtoFile(this.sigCanvas.getTrimmedCanvas().toDataURL('image/png'), 'signatoryStaffSignature.png')
      });
      handleAnswerChanged('signatory_review', this.state.signature, 'signature');
    }
  }

  clearSignature = () => {
    const { handleAnswerChanged, application } = this.props;
    this.sigCanvas.clear();
    if (application && (application?.current_stage === 'signatory_review' || application?.current_stage === 'sigantory_review')) {
      this.setState({
        signature: ''
      });
      handleAnswerChanged('signatory_review', '', 'signature');
    }
  }

  dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr?.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  ssnViewSelect = (id) => {
    const { ssnView } = this.state;
    this.setState({
      ssnView: !ssnView, selectedId: id
    });
  }

  render() {
    const { application, translation, error, tabSelected, user, signatoryCustomFields, requiredMap,
      response, showFormErrors, handleAnswerChanged, handleFieldErrorChanged, settings, access, accessArea, subAccessArea, accessError } = this.props;
    const { modalA, modalB, initialSlide, initialSlideA, ssnView, selectedId, modalC, initialSlideC } =this.state;
    const gender = application?.response?.gender;
    const GenderValue = application?.form?.schema?.fields?.filter(field => field.id === 'gender');
    const genderName = GenderValue?.[0]?.values?.filter(fil => fil.key === gender);
    const race = application?.response?.ethnicity;
    const raceValue = application?.form?.schema?.fields?.filter(field => field.id === 'ethnicity');
    const ethnicity = raceValue?.[0]?.values?.filter(fil => fil.key === race);
    const eyeColor = application?.response?.eye_color;
    const eyeColorValue = application?.form?.schema?.fields?.filter(field => field.id === 'eye_color');
    const eyeColorName = eyeColorValue?.[0]?.values?.filter(fil => fil.key === eyeColor);
    const hairColor = application?.response?.hair_color;
    const hairColorValue = application?.form?.schema?.fields?.filter(field => field.id === 'hair_color');
    const hairColorName = hairColorValue?.[0]?.values?.filter(fil => fil.key === hairColor);
    const typeOfBadgeInfo = application?.form?.schema?.fields?.find(field => field.id === 'type_of_badge') || {};
    const typeOfBadgeValue = typeOfBadgeInfo.values?.filter(val => val.key === application?.response?.type_of_badge) || [];
    const customFields = application.answer_schema?.fields?.filter(field => field.default === false && !field.isDisabled && !field.disable_for_portal) || [];
    const checkboxChecked = application && application.answer_schema?.fields?.filter(fil => Object.keys((application && application?.response) || {}).filter(filt => ['check1', 'check2', 'check3']?.includes(filt))?.includes(fil.id)) || [];
    const multipleRemarks = [];
    const isComment = application?.status === 2;
    if (application && application?.additional_info !== null && application?.additional_info?.[0]?.multipleRemarks) {
      Object.keys(application?.additional_info[0]?.multipleRemarks || {}).forEach((f) => {
        if (application?.additional_info[0]?.multipleRemarks?.[f]) {
          multipleRemarks.push({ name: f });
        }
      });
    }
    const felonyInvolvingRemarks = [];
    if (application && application?.additional_info !== null && application?.additional_info?.[0]?.felonyInvolvingRemarks) {
      Object.keys(application?.additional_info[0]?.felonyInvolvingRemarks || {}).forEach((f) => {
        if (
            application?.additional_info[0]?.felonyInvolvingRemarks?.[f]
        ) {
          felonyInvolvingRemarks.push({ name: f });
        }
      });
    }
    const signatureType = application && application?.answer_schema?.fields?.filter(fi => fi.id === 'signature');
    const citizenship = application.form?.schema?.fields?.filter(field => field.id === 'nation_of_citizenship' && !field.isDisabled);
    const getStreetValue = (address) => {
    const street = address?.street;
      if (typeof street === 'string') {
        return street;
      }
      if (typeof street === 'object' && street !== null) {
        if ('street' in street) {
          return street.street || '';
        }
        return street.selected_address || street.fulladdress || '';
      }
      return '';
    };
    return (
      <>
      {tabSelected === 'application' && (
      <>
        <Collapsible
          title="Personal Information"
          styleClasses={styles.collapsibleHeader}
          offset={400}
          collapsibleHeight="0"
        >
          <div className={`${styles.requestInfo} ${styles.columnLayout}`}>
            <div className={styles.infoTable}>
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="airfields.comments.firstname"
                    defaultMessage="Logged by"
                  />
                </span>
                <span className={styles.rowContent}>
                  {application && application.first_name}
                </span>
                {application.form?.schema?.fields?.map(field => (
                  <>
                    {field.id === 'middle_name' && !field?.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.middle_name}</span>
                      </>
                    )}
                  </>
                ))}
                <span className={styles.title}>
                  <FormattedMessage
                    id="airfields.comments.lastname"
                    defaultMessage="Report date"
                  />
                </span>
                <span className={styles.rowContent}>
                  {application && application?.last_name}
                </span>
                <span className={`${styles.title} mt-4 mb-4`}>
                  <FormattedMessage
                    id="portal.user.suffix"
                    defaultMessage="Suffix"
                  />
                </span>
                <span className={styles.rowContent}>
                  {application &&application?.suffix}
                </span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="application.detail.request.phone"
                    defaultMessage="Phone"
                  />
                </span>
                <span className={styles.rowContent}>{application?.phone_number}</span>
                <span className={styles.title}>
                  <FormattedMessage
                    id="application.detail.request.email"
                    defaultMessage="Email"
                  />
                </span>
                <span className={styles.rowContent}>{application?.email}</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="application.detail.request.phones"
                    defaultMessage="Privileges"
                  />
                </span>
                <span className={styles.rowContent}>{application?.access_area}</span>
                {application && application?.sub_access_areas?.length > 0 && (
                <>
                <span className={styles.title}>
                  <FormattedMessage
                    id="application.detail.request.emails"
                    defaultMessage="Sub-Previleges"
                  />
                </span>
                <span className={styles.rowContent}>{application?.sub_access_areas}</span>
                </>
                )}
              </div>
                {(application?.response?.aliases_first) || (application?.response?.aliases_middle) || (application?.response?.aliases_last)
                ? <div className={styles.infoRow}>
                  {application.form?.schema?.fields?.map(sch => sch.id === 'aliases_first' && !sch.isDisabled && (
                    <>
                    <span className={styles.title}>
                    <FormattedMessage
                    id={sch.id}
                    defaultMessage={sch.title}
                    />
                    </span>
                    <span className={styles.rowContent}>{application?.response?.aliases_first}</span>
                    </>
                  ))}
                  {application.form?.schema?.fields?.map(sch => sch.id === 'aliases_middle' && !sch.isDisabled && (
                    <>
                    <span className={styles.title}>
                    <FormattedMessage
                    id={sch.id}
                    defaultMessage={sch.title}
                    />
                    </span>
                    <span className={styles.rowContent}>{application?.response?.aliases_middle}</span>
                    </>
                  ))}
                  {application.form?.schema?.fields?.map(sch => sch.id === 'aliases_last' && !sch.isDisabled && (
                    <>
                    <span className={styles.title}>
                    <FormattedMessage
                    id={sch.id}
                    defaultMessage={sch.title}
                    />
                    </span>
                    <span className={styles.rowContent}>{application?.response?.aliases_last}</span>
                    </>
                  ))}
                  </div>
                : ''
                }
                {(application?.response?.street?.street || application?.response?.street)
                || (application?.response?.street?.city || application?.response?.city)
                ? <div className={styles.infoRow}>
                    {application.form?.schema?.fields?.map(field => field.id === 'street' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>
                          {getStreetValue(application?.response)}
                        </span>
                      </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'city' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.street?.city || application?.response?.city}</span>
                      </>
                    ))}
                  </div>
                : ''
                }
                {(application?.response?.street?.state) || (application?.response?.street?.zip) || (application?.response?.street?.country)
                || (application?.response?.state) || (application?.response?.zip) || (application?.response?.country)
                ? <div className={styles.infoRow}>
                    {application.form?.schema?.fields?.map(field => field.id === 'state' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.street?.state || application?.response?.state}</span>
                      </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'zip' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.street?.zip || application?.response?.zip}</span>
                      </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'country' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.street?.country?.label || application?.response?.country?.label}</span>
                      </>
                    ))}
                  </div>
                : ''
                }

                {(application?.response?.date_of_birth) || (application?.response?.place_of_birth)
                ? <div className={styles.infoRow}>
                    {application.form?.schema?.fields?.map(field => field.id === 'date_of_birth' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.date_of_birth && renderInfoForType({ 'type': 'date' }, application?.response?.date_of_birth, null, null)}</span>
                      </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'place_of_birth' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>
                          {this.getPlaceOfBirth(application)}
                        </span>
                      </>
                    ))}
                  </div>
                : ''
                }
                {((citizenship && Object.keys(citizenship)?.length > 0) || ethnicity?.length > 0 || genderName?.length > 0)
                ? <div className={styles.infoRow}>
                    {application.form?.schema?.fields?.map(field => field.id === 'nation_of_citizenship' && !field.isDisabled && (
                        <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.nation_of_citizenship?.label}</span>
                        </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'ethnicity' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{ethnicity && ethnicity[0]?.value}</span>
                      </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'gender' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{genderName && genderName[0]?.value}</span>
                      </>
                    ))}
                  </div>
                : ''
                }
                {(application?.response?.height) || (application?.response?.weight)
                ? <div className={styles.infoRow}>
                    {application.form?.schema?.fields?.map(field => field.id === 'height' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.height}</span>
                      </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'weight' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{application?.response?.weight}</span>
                      </>
                    ))}
                  </div>
                : ''
                }
                {(eyeColorName && Object.keys(eyeColorName)?.length > 0) || (hairColorName && Object.keys(hairColorName)?.length > 0)
                ? <div className={styles.infoRow}>
                    {application.form?.schema?.fields?.map(field => field.id === 'eye_color' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{eyeColorName && eyeColorName[0]?.value}</span>
                      </>
                    ))}
                    {application.form?.schema?.fields?.map(field => field.id === 'hair_color' && !field.isDisabled && (
                      <>
                        <span className={styles.title}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                        </span>
                        <span className={styles.rowContent}>{hairColorName && hairColorName[0]?.value}</span>
                      </>
                    ))}
                  </div>
                : ''
                }

                {typeOfBadgeValue && application.form?.schema?.fields?.map(field => field.id === 'type_of_badge' && !field.isDisabled && (
                  <div className={styles.infoRow}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                      />
                    </span>
                    <span className={styles.rowContent}>{typeOfBadgeValue && typeOfBadgeValue[0]?.value}</span>
                  </div>
                ))}
            </div>
              {customFields?.length > 0 && (
                <div>
                  <CustomFieldDetail
                    data={application.response}
                    version={application?.answer_schema?.version}
                    fields={customFields}
                    badging
                    badgeData={application}
                  />
                </div>
              )}
          </div>
        </Collapsible>
        { isComment
        && <Collapsible
            title="Reason for Rejection"
            styleClasses={styles.collapsibleHeader}
            offset={400}
            collapsibleHeight="0"
          >
            <div className={` ${styles.noMarginTop} ${styles.commentCard}`}>
                <p>{application?.badge_comments?.comment || ''}</p>
            </div>
           </Collapsible>}
        {application.form?.schema?.fields?.some(n => (n.id === 'employer' && !n.isDisabled) || (n.id === 'job_title' && !n.isDisabled) || (n.id === 'employer_address' && !n.isDisabled)) && (
        <Collapsible
        title="Employer Information"
        styleClasses={styles.collapsibleHeader}
        offset={400}
        collapsibleHeight="0"
        >
          <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
            {application && application.form?.schema?.fields.map(f => (
              <>
                {f.type!=='header' && (f.id === 'employer') && !f?.isDisabled && (
                  <div
                  key={f.id}
                  className={
                    f.widget && f.widget.type === 'textfield'
                      ? styles.infoFull
                      : styles.infoHalf
                  }
                >
                    <span>
                      {f.type!=='header' && translation && translation[f.title]
                        ? translation[f.title]
                        : f.title}
                    </span>
                    <p>{application?.company_name && application?.company_name?.name}</p>
                  </div>
                )}
                {f.type!=='header' && (f.id==='job_title'|| f.id==='city_state_zip') && !f?.isDisabled && (
                    <div
                      key={f.id}
                      className={
                        f.widget && f.widget.type === 'textfield'
                          ? styles.infoFull
                          : styles.infoHalf
                      }
                    >
                      <span>
                        {f.type!=='header' && translation && translation[f.title]
                          ? translation[f.title]
                          : f.title}
                      </span>
                      <p>{application && application?.response && application?.response?.[f.id]&& renderInfoForType(f, application?.response?.[f.id], application, false, true)}</p>
                    </div>
                )}
              </>
            ))}
          </div>
        </Collapsible>
        )}
        {application.form?.schema?.fields?.some(f => ((f.id === 'social_security_number' && !f.isDisabled)
          || (f.id === 'passport' && !f.isDisabled) || (f.id === 'passport_country' && !f.isDisabled) || (f.id === 'alien_registration_number' && !f.isDisabled)
          || (f.id === 'drivers_license_number' && !f.isDisabled) || (f.id === 'driver_state' && !f.isDisabled))) && (
        <Collapsible
        title="Identification"
        styleClasses={styles.collapsibleHeader}
        offset={400}
        collapsibleHeight="0"
        >
          <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
            {application.form?.schema?.fields?.map(field => (
              <>
                {field.id === 'social_security_number' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                    id={field.id}
                    defaultMessage={field.title}
                    />
                  </span>
                    <p>{ssnView && selectedId=== field?.id ?application?.response?.social_security_number : 'XXXXXX'}</p>
                  {application?.response?.social_security_number && (
                    <div style={{ marginTop: '19px', cursor: 'pointer' }}><LockRounded onClick={() => { this.ssnViewSelect(field?.id); }} /></div>
                  )}
                </div>
                )}
                {field.id === 'passport' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                    id={field.id}
                    defaultMessage={field.title}
                    />
                  </span>
                  <p>{application?.response?.passport}</p>
                </div>
                )}
                {field.id === 'passport_country' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                    id={field.id}
                    defaultMessage={field.title}
                    />
                  </span>
                  <p>{application?.response?.passport_country?.label}</p>
                </div>
                )}
                {field.id === 'alien_registration_number' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                    id={field.id}
                    defaultMessage={field.title}
                    />
                  </span>
                  <p>{application?.response?.alien_registration_number}</p>
                </div>
                )}
                {field.id === 'drivers_license_number' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                  </span>
                  <p>{application?.response?.drivers_license_number}</p>
                </div>
                )}
                {field.id === 'driver_state' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                  </span>
                  <p>{application?.response?.driver_state?.value}</p>
                </div>
                )}
              </>
            ))}
          </div>
        </Collapsible>
        )}
        {application && application?.attachments_listA?.length > 0 && application?.attachments_listA[0]?.content_type !== '' && (
          <Collapsible
          title="List A Documents"
          styleClasses={styles.collapsibleHeader}
          offset={400}
          collapsibleHeight="0"
          >
            {application?.attachments_listA?.length > 0 && (
              <div className={attachmentStyles.attachmentbox}>
                  <div className={application.attachments_listA?.length > 1 ? attachmentStyles.photos : attachmentStyles.photo}>
                    {application?.attachments_listA?.map((e, idx) => (
                      <>
                    {e.content_type?.includes('image') && (
                      <Clickable
                      key={e.id}
                      onClick={() => this.openPhotoModalA(idx)}
                      className={`mt-4 ${attachmentStyles.pdflink} ml-4`}
                    >
                      {e.file_name}
                      </Clickable>
                    )}
                    {e.content_type === 'application/pdf' && (
                      <a href={e.url} target="_blank" rel="noopener noreferrer" className={`mt-4 ${attachmentStyles.pdflink} ml-4`}>{e.file_name}</a>
                    )}
                      </>
                    ))}
                  </div>
              </div>
            )}
          </Collapsible>
        )}
        {application && application?.attachments_listB?.length > 0 && application?.attachments_listB[0]?.content_type !== '' && (
          <Collapsible
            title="List B Documents"
            styleClasses={styles.collapsibleHeader}
            offset={400}
            collapsibleHeight="0"
          >
            {application?.attachments_listB?.length > 0 && (
              <div className={attachmentStyles.attachmentbox}>
                  <div className={application.attachments_listB?.length > 1 ? attachmentStyles.photos : attachmentStyles.photo}>
                    {application?.attachments_listB?.map((e, idx) => (
                      <>
                    {e.content_type?.includes('image') && (
                        <Clickable
                        key={e.id}
                        onClick={() => this.openPhotoModal(idx)}
                        className={`mt-4 ${attachmentStyles.pdflink} ml-4`}
                      >
                        {e.file_name}
                        </Clickable>
                      )}
                      {e.content_type === 'application/pdf' && (
                        <a href={e.url} target="_blank" rel="noopener noreferrer" className={`mt-4 ${attachmentStyles.pdflink} ml-4`}>{e.file_name}</a>
                      )}
                      </>
                    ))}
                  </div>
              </div>
            )}
          </Collapsible>
        )}
        {application && application?.attachments_listC?.length > 0 && application?.attachments_listC[0]?.content_type !== '' && (
          <Collapsible
          title="List C Documents"
          styleClasses={styles.collapsibleHeader}
          offset={400}
          collapsibleHeight="0"
          >
            {application?.attachments_listC?.length > 0 && (
              <div className={attachmentStyles.attachmentbox}>
                  <div className={application.attachments_listC?.length > 1 ? attachmentStyles.photos : attachmentStyles.photo}>
                    {application?.attachments_listC?.map((e, idx) => (
                      <>
                    {e.content_type?.includes('image') && (
                      <Clickable
                      key={e.id}
                      onClick={() => this.openPhotoModalC(idx)}
                      className={`mt-4 ${attachmentStyles.pdflink} ml-4`}
                    >
                      {e.file_name}
                      </Clickable>
                    )}
                    {e.content_type === 'application/pdf' && (
                      <a href={e.url} target="_blank" rel="noopener noreferrer" className={`mt-4 ${attachmentStyles.pdflink} ml-4`}>{e.file_name}</a>
                    )}
                      </>
                    ))}
                  </div>
              </div>
            )}
          </Collapsible>
        )}
        {(settings && settings?.checkbox_section) && (application && application?.current_stage !== 'initiated' && application?.application_filled_by === 'Applicant' && application?.additional_info !== null) && (
         <Collapsible
          title="DISQUALIFYING CRIMINAL OFFENSES – SIDA/SECURED/STERILE/AOA ONLY"
          styleClasses={styles.collapsibleHeader}
          offset={400}
          collapsibleHeight="0"
        >
          <div>
            <p>FAR §1542.209 (d) An individual has a disqualifying offense if the individual has been convicted, or found not guilty of or by reason of insanity, of any of the disqualifying crimes listed in this paragraph in any jurisdiction during the 10 years before the date of the individual’s application for unescorted access authority, or while the individual has unescorted access authority.</p>
            <p style={{ marginTop: '10px', fontWeight: 'bold' }}>HAVE YOU BEEN CONVICTED, OR FOUND NOT GUILTY BY REASON OF INSANITY OF ANY OF THE FOLLOWING IN THE PAST 10 YEARS?</p>
            {multipleRemarks?.length > 0 && (
              <>
              {multipleRemarks?.map(mul => <p className="mb-1"><li style={{ color: 'red', fontWeight: 'bold' }}>{mul.name}</li></p>)}
              </>
            )}
            {felonyInvolvingRemarks?.length > 0 && (
              <>
              {felonyInvolvingRemarks?.map(mul => <p className="mb-1"><li style={{ color: 'red', fontWeight: 'bold' }}>{mul.name}</li></p>)}
              </>
            )}
            { application && application?.additional_info[0]?.noneCheckbox === true && (
              <p>No</p>
            )}
            <p className="mt-4">Federal regulations under 49 CFR 1542.209(I) impose a continuing obligation to disclose to the airport operator within 24 hours if he or she is convicted of
                any disqualifying criminal offense that occurs while he or she has unescorted access authority.
            </p>
            <p className="mt-3">By signing this application below I acknowledge that I have not been convicted or found not guilty by reason of insanity of any of the disqualifying
                criminal offenses listed within the last 10 years, nor have I been arrested for any of the disqualifying offenses and am awaiting judicial proceedings.
                Additionally, by signing this application below I acknowledge that I will notify {user?.portal_airport?.name} within 24 hours if I am convicted or found not guilty by reason of
                insanity of any disqualifying criminal offense while I have unescorted access authority.
            </p>
            <p className="mt-3">If the background check contains any outstanding warrant(s) for your arrest for any offense(s) , whether disqualifiable or not, your security badge will
                be denied until such time as documentation is provided to the ASC that said warrant(s) have been cleared from your record and are no longer active.
            </p>
          </div>
         </Collapsible>
        )}
        {application?.response?.signature !== undefined && application?.response?.signature?.length > 0 &&(
          <Collapsible
            title={typeof application?.response?.signature === 'object' ? 'Applicant Signature' : signatureType?.[0]?.title}
            styleClasses={styles.collapsibleHeader}
            offset={400}
            collapsibleHeight="0"
          >
            {typeof application?.response?.signature === 'object'
            ? <div className={styles.requestInfoField}>
              <div className={styles.photo}>
                {application?.response?.signature?.map(e => (
                  <>
                    {e.content_type?.includes('image') && (
                      <img src={e.url} alt={e.id} />
                    )}
                  </>
                ))}
              </div>
              </div>
            : <div className={styles.requestInfo}>
                <div className={styles.infoTable}>
                  <div className={styles.infoRow}>
                    <div className={styles.infoFull}>
                      <span className={styles.rowContent}>{application?.response?.signature}</span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </Collapsible>
        )}
        {application && application?.signatory_review_signature && application.signatory_review_signature?.length > 0 && (
          <>
            <Collapsible
              title="Signatory Signature"
              styleClasses={styles.collapsibleHeader}
              offset={400}
              collapsibleHeight="0"
              openOnMount
            >
              <div className={styles.requestInfoField}>
                  <div className={styles.photo}>
                    {application?.signatory_review_signature?.map(e => (
                      <>
                        {e.content_type?.includes('image') && (
                          <img src={e.url} alt={e.id} />
                        )}
                      </>
                    ))}
                  </div>
              </div>
            </Collapsible>
          </>
        )}
        {application && Object.keys(application?.signatory_response || {})?.length > 0 && (
          <Collapsible
          title="Signatory Custom Fields"
          styleClasses={styles.collapsibleHeader}
          offset={400}
          collapsibleHeight="0"
          >
            <CustomFieldDetail
            data={application?.signatory_response}
            fields={signatoryCustomFields?.schema?.fields}
            fromBadgeSignatory
            />
          </Collapsible>
        )}
      </>
    )}
    {tabSelected === 'acknowledgement' && (
      <>
        <Collapsible
          title="Applicant acknowledges their security responsibilities under 49 CFR 1540.105(a)"
          styleClasses={styles.collapsibleHeader}
          offset={400}
          collapsibleHeight="0"
        >
          <div>
              <p style={{ borderBottom: '1px solid #E6EAEE' }}>(a) No person may: </p>
              <p>(1) Tamper or interfere with, compromise, modify, attempt to
              circumvent, or cause a person to tamper or interfere with,
              compromise, modify, or attempt to circumvent any security system,
              measure, or procedure implemented under this subchapter.
              </p>
              <p>(2) Enter, or be present within, a secured area, AOA, SIDA or sterile
              area without complying with the systems, measures, or procedures
              being applied to control access to, or presence or movement in, such
              areas.
              </p>
              <p>(3) Use, allow to be used, or cause to be used, any airport-issued or
              airport-approved access medium or identification medium that
              authorizes the access, presence, or movement of persons or vehicles
              in secured areas, AOA&apos;s, or SIDA&apos;s in any other manner than that for
              which it was issued by the appropriate authority under this
              subchapter.
              </p>
          </div>
          {checkboxChecked && checkboxChecked?.length > 0 && (
            <div className="mt-4">
            {checkboxChecked?.map(che => (
              <div style={{ display: 'flex', marginTop: '10px' }}>
              <Checkbox
                checked
              />
              {che.title}
              </div>
            ))}
            </div>
          )}
        </Collapsible>
        {application?.additional_info?.[0]?.agreements && Object.keys(application?.additional_info[0]?.agreements).length > 0 && (
        <Collapsible
          title="AGREEMENTS"
          styleClasses={styles.collapsibleHeader}
          offset={400}
          collapsibleHeight="0"
        >
          <div className="mt-2">

            {Object.entries(application?.additional_info[0]?.agreements)?.filter(([key]) => key !== 'door' && key !== 'rules' && key !== 'airside')?.map(([key, value]) => (
                <div key={key}>
                    <p style={{ marginBottom: '0px' }}><b>{key}&nbsp;</b></p>
                    <div style={{ marginBottom: '20px' }}>
                      <input
                          name={value}
                          id={value}
                          disabled
                          type="text"
                          value={value}
                      />
                    </div>
                </div>
            ))}
          </div>
        </Collapsible>
        )}
      </>
    )}
    {application && (application?.current_stage==='signatory_review' || application?.current_stage === 'sigantory_review') && application?.status !== 2 && (
      <Collapsible
      title="Signatory Review Step"
      styleClasses={styles.collapsibleHeader}
      offset={400}
      collapsibleHeight="0"
      >
      {settings && settings?.application_fill_up_privilege_type === 'signatory_staff' && (
      <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <label
            htmlFor="access_area"
            style={{
              color: '#8C9EA7',
              fontSize: '16px',
              lineHeight: '26px',
              display: 'block',
              marginBottom: '0px'
            }}
          >
            <span style={{ color: 'red' }}>*</span> Privilege Types
          </label>
        <Select
          isMulti
          value={
          Array.isArray(accessArea)
            ? accessArea.map(v => (typeof v === 'object'
                ? v
                : { label: v, value: v }))
            : []
          }
          onChange={selected => handleAnswerChanged('signatory_review', selected, 'access_area')}
          options={_.sortBy(access && access.access_areas
          ? access.access_areas.map(e => ({
            label: `${e.name}`,
            value: e.name
          }))
          : [], [eachCategory => eachCategory.value.toLowerCase()])}
          maxMenuHeight={300}
        />
        {accessError && (
          <small style={{ color: 'red' }}>This field cannot be empty</small>
        )}
        </div>
      {Array.isArray(accessArea)
      && access?.sub_access_areas?.filter(i => accessArea.some(a => a.value === i.access_areas_name) && i.name !== '').length > 0 && (
        <div style={{ flex: 1 }}>
        <label
          htmlFor="sub_access_areas"
          style={{
            color: '#8C9EA7',
            fontSize: '16px',
            lineHeight: '26px',
            display: 'block',
            marginBottom: '6px'
          }}
        >
          <span style={{ color: 'red' }}>*</span> Sub-Previlege-Types
        </label>
          <Select
            isMulti
            value={
              Array.isArray(subAccessArea)
                ? subAccessArea.map(v => (typeof v === 'object' ? v : { label: v, value: v }))
                : []
            }
            onChange={selected => handleAnswerChanged('signatory_review', selected, 'sub_access_areas')}
            options={_.sortBy(
              access?.sub_access_areas?.filter(s => accessArea?.some(a => a.value.toLowerCase()=== s.access_areas_name?.toLowerCase()))?.map(e => ({
                label: e.name,
                value: e.name
              })) || [],
              [each => each.value.toLowerCase()]
            )}
            maxMenuHeight={300}
          />
        </div>
      )}
      </div>
      )}
      <div className="mt-4">
        <div style={{ display: 'flex' }}>
        <small style={{ color: 'red' }}> * </small>
        <FormattedMessage
              id="Badging.airportstaffsignature"
              defaultMessage="Signatory Staff Signature"
        />
        </div>
      <SignatureCanvas
        ref={(ref) => { this.sigCanvas = ref; }}
        penColor="black"
        canvasProps={{ width: 760, height: 152, className: styles.sigCanvas }}
        onEnd={this.handleSignatureEnd}
      />

      <Button
        action="tertiary"
        onClick={this.clearSignature}
        translationID="filters.form.clear"
        defaultText="clear"
        className={styles.button}
      />

      {error && (
        <div>
          <small style={{ color: 'red' }}>
            <FormattedMessage id="pulpoforms.errors.not_blank"
            defaultMessage="This field cannot be empty"
            />
          </small>
        </div>
      )}
      </div>
      {Object.keys(requiredMap)?.length > 0 && (
        <CustomFields
        handleAnswerChanged={(a, b) => handleAnswerChanged('response', a, b)}
        handleFieldErrorChanged={handleFieldErrorChanged}
        showFormErrors={showFormErrors}
        requiredMap={requiredMap}
        errorsList={[]}
        placeHolders={[]}
        fields={signatoryCustomFields?.schema?.fields || []}
        answers={response}
        Badging
        />
      )}
      </Collapsible>
      )}
      {application && application?.badge_number && application?.current_stage === 'completed' && (
        <Collapsible
        title="Badge Number"
        styleClasses={styles.collapsibleHeader}
        offset={400}
        collapsibleHeight="0"
        >
          <div className={styles.requestInfoField}>
            <p style={{ margin: '10px', fontWeight: 'bold' }}>{application?.badge_number}</p>
          </div>
        </Collapsible>
      )}
      {application?.badge_expiry_date && application?.current_stage === 'completed' && (
        <Collapsible
        title="Badge Expiry Date"
        styleClasses={styles.collapsibleHeader}
        offset={400}
        collapsibleHeight="0"
        >
          <div className={styles.requestInfoField}>
            <p>
              {application?.badge_expiry_date && renderInfoForType({ 'type': 'date' }, application?.badge_expiry_date, null, null)}
            </p>
          </div>
        </Collapsible>
      )}
      {application && application.attachments_listA && application.attachments_listA?.length > 0 && (
        <Modal
          showIn={modalA}
          onClose={() => this.setState({ modalA: false })}
          contentStyles={{
            overflow: 'visible',
            padding: '20px 40px',
             width: '943px'
          }}
        >
          <div>
            <Clickable style={{ borderBottom: '1px solid #E6EAEE',
              marginBottom: '10px',
              paddingBottom: '10px',
              textAlign: 'right' }}
              onClick={() => this.setState({ modalA: false })}>
                <img
                  src={closeIcon}
                  style={{ cursor: 'pointer' }}
                  alt="closeIcon"
                />
            </Clickable>
            {application.attachments_listA && application.attachments_listA?.length > 0 && (
              <FileSlider photos={application?.attachments_listA} initialSlide={initialSlideA}
              badgeAttachmentDetails={application?.forms_of_identification?.attachments_listA} />
            )}
          </div>
        </Modal>
      )}
      {application && application.attachments_listB && application.attachments_listB?.length > 0 && (
        <Modal
          showIn={modalB}
          onClose={() => this.setState({ modalB: false })}
          contentStyles={{
            overflow: 'visible',
            padding: '20px 40px',
             width: '943px'
          }}
        >
        <div>
          <Clickable style={{ borderBottom: '1px solid #E6EAEE',
          marginBottom: '10px',
          paddingBottom: '10px',
          textAlign: 'right' }}
          onClick={() => this.setState({ modalB: false })}>
            <img
              src={closeIcon}
              style={{ cursor: 'pointer' }}
              alt="closeIcon"
            />
          </Clickable>
          {application.attachments_listB &&application.attachments_listB?.length > 0 && (
            <FileSlider photos={application?.attachments_listB} initialSlide={initialSlide}
            badgeAttachmentDetails={application?.forms_of_identification?.attachments_listB} />
          )}
        </div>
        </Modal>
      )}
      {application && application.attachments_listC && application.attachments_listC?.length > 0 && (
        <Modal
          showIn={modalC}
          onClose={() => this.setState({ modalC: false })}
          contentStyles={{
            overflow: 'visible',
            padding: '20px 40px',
             width: '943px'
          }}
        >
        <div>
          <Clickable style={{ borderBottom: '1px solid #E6EAEE',
          marginBottom: '10px',
          paddingBottom: '10px',
          textAlign: 'right' }}
          onClick={() => this.setState({ modalC: false })}>
            <img
              src={closeIcon}
              style={{ cursor: 'pointer' }}
              alt="closeIcon"
            />
          </Clickable>
          {application.attachments_listC &&application.attachments_listC?.length > 0 && (
            <FileSlider photos={application?.attachments_listC} initialSlide={initialSlideC}
            badgeAttachmentDetails={application?.forms_of_identification?.attachments_listC} />
          )}
        </div>
        </Modal>
      )}
      </>
    );
  }
}

ApplicationInfo.propTypes = {
  workorder: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired
};

export default ApplicationInfo;
